var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isMercedes)?_c('div',[_c('iframe',{staticClass:"mercedes-consent",attrs:{"src":_vm.iframeUrl}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }